import { Cell, Checkbox } from '@wix/design-system';
import * as React from 'react';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { withTranslation } from '../../../component-decorators/with-translation';
import type { SubCategory } from '@wix/ambassador-marketplace/types';

interface SelectorCheckBoxMobileProps extends Partial<WithTranslationProps> {
  subCategory: SubCategory;
  subCategoriesCount: number;
  checkedSubCategories: SubCategory[];
  setCheckedSubCategories(subCategoriesNames: SubCategory[]): void;
}

@withTranslation
export class SelectorCheckBoxMobile extends React.Component<
  SelectorCheckBoxMobileProps,
  any
> {
  constructor(props) {
    super(props);
    this.onSubCategoriesCheck = this.onSubCategoriesCheck.bind(this);
    this.wasSubCategoryChecked = this.wasSubCategoryChecked.bind(this);
  }

  onSubCategoriesCheck = () => {
    const {
      subCategory,
      subCategoriesCount,
      setCheckedSubCategories,
      checkedSubCategories,
    } = this.props;
    let subCategories = checkedSubCategories || [];
    const selectedAllSubCategories =
      !subCategory ||
      (!subCategories.includes(subCategory) &&
        subCategories.length + 1 === subCategoriesCount);
    if (selectedAllSubCategories) {
      subCategories = [];
    } else {
      subCategories = this.wasSubCategoryChecked()
        ? subCategories.filter((sub) => sub.slug !== subCategory.slug)
        : [...subCategories, subCategory];
      subCategories = subCategories.length ? subCategories : [];
    }
    setCheckedSubCategories(subCategories);
  };

  wasSubCategoryChecked = (): boolean => {
    const { subCategory, subCategoriesCount, checkedSubCategories } =
      this.props;
    const subCategories = checkedSubCategories || [];
    return !subCategory
      ? subCategories.length === 0 ||
          subCategories.length === subCategoriesCount
      : subCategories.find((sub) => sub.slug === subCategory.slug) &&
          subCategories.length !== subCategoriesCount;
  };

  render() {
    const { subCategory, t } = this.props;
    return (
      <Cell>
        <Checkbox
          checked={this.wasSubCategoryChecked()}
          onChange={() => this.onSubCategoriesCheck()}
        >
          {subCategory
            ? subCategory.name
            : t('category.filter-subcategory.all')}
        </Checkbox>
      </Cell>
    );
  }
}
